import type { RouteRecordRaw } from 'vue-router'
import { adminBaseRoutePath } from '/@/router/static/adminBase'
// import { memberCenterBaseRoutePath } from '/@/router/static/memberCenterBase'

const pageTitle = (name: string): string => {
  return `pagesTitle.${name}`
}

/*
 * 静态路由
 * 自动加载 ./static 目录的所有文件，并 push 到以下数组
 */
const staticRoutes: Array<RouteRecordRaw> = [
  // {
  //   path: '/',
  //   name: 'layout',

  //   redirect: '/home',
  //   children: [
  //   ],
  // },
  {
    path: '/home',
    name: 'home',
    component: () => import('/@/views/LayoutContainer.vue'),
    // component: () => import('/@/views/HomePage.vue'),
    redirect: '/home/index',
    meta: {
      title: '数匠云 | 领先的工程AI应用平台'
    },
    children: [
      {
        path: 'index',
        name: 'homepage',
        component: () => import('/@/views/HomePage.vue'),
        meta: {
          title: '官网'
        }
      },
      {
        path: 'news',
        name: 'newspage',
        component: () => import('/@/views/Newspage.vue'),
      },
      {
        path: 'detail',
        name: 'news',
        component: () => import('/@/views/NewsDetail.vue'),
      },
    ]
  },
  // 注意：根路径的动态重定向逻辑在 router/index.ts 的 beforeEach 中处理
  // 请勿在此处添加 redirect，否则会导致登录状态判断失效
  {
    path: '/',
    name: 'root',
    component: () => import('/@/layouts/frontend/chat.vue'),
    children: [
      {
        path: 'homeIndex',
        name: 'homeIndex',
        component: () => import('/@/views/frontend/apply/homeIndex.vue'),
        meta: {
          title: '首页'
        }
      },
      {
        path: 'plan',
        name: 'plan',
        redirect: '/plan/planIndex',
        component: () => import('/src/views/frontend/apply/plan/plan.vue'),
        meta: {
          title: '方案'
        },
        children: [
          {
            path: 'planIndex',
            name: 'planIndex',
            component: () => import('/@/views/frontend/apply/plan/planIndex.vue'),
            meta: {
              title: '方案首页'
            }
          }, {
            path: 'basicInformation',
            name: 'basicInformation',
            component: () => import('/@/views/frontend/apply/plan/basicInformation.vue'),
            meta: {
              title: '基础信息'
            }
          }, {
            path: 'parameterSetting',
            name: 'parameterSetting',
            component: () => import('/@/views/frontend/apply/plan/parameterSetting.vue'),
            meta: {
              title: '参数设置'
            }
          }, {
            path: 'outlineGeneration',
            name: 'outlineGeneration',
            component: () => import('/@/views/frontend/apply/plan/outlineGeneration.vue'),
            meta: {
              title: '生成大纲'
            }
          }, {
            path: 'contentArrangement',
            name: 'contentArrangement',
            component: () => import('/@/views/frontend/apply/plan/contentArrangement.vue'),
            meta: {
              title: '内容编排'
            }
          }, {
            path: 'writingPage',
            name: 'writingPage',
            component: () => import('/@/views/frontend/apply/plan/writingPage.vue'),
            meta: {
              title: '写作'
            }
          }
        ]
      },
      // {
      //   path: 'writing',
      //   name: 'writing',
      //   component: () => import('/@/views/frontend/apply/writing.vue'),
      //   meta: {
      //     title: '方案列表'
      //   }
      // },
      {
        path: 'WebOffice',
        name: 'WebOffice',
        component: () => import('/@/components/apply/Onlyoffice/index.vue'),
        // component: () => import('/@/components/apply/WebOffice/Demo.vue'),
        meta: {
          title: '方案列表'
        }
      },
      {
        path: 'WangEditor',
        name: 'WangEditor',
        component: () => import('/@/components/apply/WangEditor/demo.vue'),
        meta: {
          title: '方案列表'
        }
      },
      // {
      // 	path: 'docxtest',
      // 	name: 'docxtest',
      // 	component: () => import('/@/views/test/DocxTest.vue'),
      // 	meta: {
      // 		title: 'DOCX 功能测试',
      // 	},
      // },
      // {
      // 	path: 'docximport',
      // 	name: 'docximport',
      // 	component: () => import('/@/views/test/DocxImportTest.vue'),
      // 	meta: {
      // 		title: 'DOCX 高级导入测试',
      // 	},
      // },
      {
        path: 'selectCompany',
        name: 'selectCompany',
        component: () => import('/@/views/frontend/apply/selectCompany.vue'),
        meta: {
          title: '选择投标企业'
        }
      },
      {
        path: 'fillBid',
        name: 'fillBid',
        component: () => import('/@/views/frontend/apply/fillBid.vue'),
        meta: {
          title: '填充投标信息'
        }
      },
      {
        path: '/createScheme',
        name: 'createScheme',
        component: () => import('/@/views/frontend/apply/createScheme.vue'),
        meta: {
          title: '创建方案'
        }
      },
      {
        path: '/startWriting',
        name: 'startWriting',
        component: () => import('/@/views/frontend/apply/startWriting.vue'),
        meta: {
          title: '写作'
        }
      },

      // {
      //   path: '/unite',
      //   name: 'unite',
      //   component: () => import('/@/views/frontend/apply/unite.vue'),
      //   meta: {
      //     title: '联合协作'
      //   }
      // },
      {
        path: '/payment_agreement',
        name: 'payment_agreement',
        component: () => import('/@/components/apply/paymentAgreement.vue'),
        meta: {
          title: '服务购买协议'
        }
      },
      {
        path: '/data_protocol',
        name: 'data_protocol',
        component: () => import('/@/components/apply/dataProtocol.vue'),
        meta: {
          title: '数据使用提前告知及授权协议'
        }
      },

      // {
      // 	path: '/test',
      // 	name: 'test',
      // 	component: () => import('/@/views/frontend/chat/test.vue'),
      // 	meta: {
      // 		title: '查看分析招标文件',
      // 	},
      // },
      {
        path: '/users',
        name: 'users',
        redirect: '/users/user',
        component: () => import('/@/views/frontend/chat/users.vue'),
        meta: {
          title: '个人中心'
        },
        children: [
          {
            path: 'user',
            name: 'user',
            component: () => import('/@/views/frontend/apply/member/index.vue'),
            meta: {
              title: '个人中心'
            }
          },
          {
            path: 'share',
            name: 'share',
            component: () => import('/@/views/frontend/apply/member/share.vue'),
            meta: {
              title: '我的邀请'
            }
          },
          {
            path: 'schemes',
            name: 'schemes',
            component: () => import('/@/views/frontend/apply/member/myBid.vue'),
            meta: {
              title: '我的方案'
            }
          },
          {
            path: 'order',
            name: 'order',
            component: () => import('/@/views/frontend/apply/member/userAllOrder.vue'),
            meta: {
              title: '我的订单'
            }
          },
          {
            path: 'withdraw',
            name: 'withdraw',
            component: () => import('/@/views/frontend/apply/member/withdraw.vue'),
            meta: {
              title: '我的订单'
            }
          },
          {
            path: 'setting',
            name: 'setting',
            component: () => import('/@/views/frontend/apply/member/accountSetting.vue'),
            meta: {
              title: '账号设置'
            }
          },
          // {
          // 	path: 'uniteSeller',
          // 	name: 'uniteSeller',
          // 	component: () => import('/@/views/frontend/apply/member/uniteSeller.vue'),
          // 	meta: {
          // 		title: '联合写作商',
          // 	},
          // },
          // {
          // 	path: 'preparers',
          // 	name: 'preparers',
          // 	component: () => import('/@/views/frontend/apply/member/preparers.vue'),
          // 	meta: {
          // 		title: '人员管理',
          // 	},
          // },
          // {
          // 	path: 'subAccount',
          // 	name: 'subAccount',
          // 	component: () => import('/@/views/frontend/apply/member/subAccount.vue'),
          // 	meta: {
          // 		title: '子账号管理',
          // 	},
          // },
          {
            path: 'private',
            name: 'private',
            component: () => import('/@/views/frontend/apply/member/private.vue'),
            meta: {
              title: '私有化配置'
            }
          },
          {
            path: 'callForBids',
            name: 'callForBids',
            component: () => import('/@/views/frontend/apply/member/callForBids.vue'),
            meta: {
              title: '招标解析记录'
            }
          },
          {
            path: 'castMarkDocument',
            name: 'castMarkDocument',
            component: () => import('/@/views/frontend/apply/member/castMarkDocument.vue'),
            meta: {
              title: '投标生成记录'
            }
          },
          {
            path: 'castMarkDocumentReview',
            name: 'castMarkDocumentReview',
            component: () => import('/@/views/frontend/apply/member/castMarkDocumentReview.vue'),
            meta: {
              title: '评分审查记录'
            }
          },
          // {
          // 	path: 'notice',
          // 	name: 'notice',
          // 	component: () => import('/@/views/frontend/apply/member/notice.vue'),
          // 	meta: {
          // 		title: '招标公告',
          // 	},
          // },
          {
            path: 'biddingAnnouncement',
            name: 'biddingAnnouncement',
            component: () => import('/@/views/frontend/apply/member/biddingAnnouncement.vue'),
            meta: {
              title: '招标公告'
            }
          },
          {
            path: 'accountManagement',
            name: 'accountManagement',
            component: () => import('/@/views/frontend/apply/member/accountManagement.vue'),
            meta: {
              title: '账号设置'
            }
          },
          // {
          // 	path: 'favorite',
          // 	name: 'favorite',
          // 	component: () => import('/@/views/frontend/apply/member/favorite.vue'),
          // 	meta: {
          // 		title: '收藏记录',
          // 	},
          // },
          {
            path: 'enterpriseManagement',
            name: 'enterpriseManagement',
            component: () => import('/@/views/frontend/apply/member/enterpriseManagement.vue'),
            meta: {
              title: '投标企业管理'
            }
          },
          {
            path: 'businessManagementDetails',
            name: 'businessManagementDetails',
            component: () => import('/@/views/frontend/apply/member/businessManagementDetails.vue'),
            meta: {
              title: '投标企业管理详情'
            }
          },
          {
            path: 'dataset',
            name: 'dataset',
            component: () => import('/@/views/frontend/apply/member/dataset.vue'),
            meta: {
              title: '查看分析招标文件'
            }
          },
          {
            path: 'gallery',
            name: 'gallery',
            component: () => import('/@/views/frontend/apply/member/gallery.vue'),
            meta: {
              title: '私有图库'
            }
          },
          {
            path: 'tenderDocumentList',
            name: 'tenderDocumentList',
            component: () => import('/@/views/frontend/apply/member/tenderDocumentList.vue'),
            meta: {
              title: '我的标书'
            }
          },
          {
            path: 'reviewList',
            name: 'reviewList',
            component: () => import('/@/views/frontend/apply/member/reviewList.vue'),
            meta: {
              title: '审查记录'
            }
          },
          {
            path: 'consumptionList',
            name: 'consumptionList',
            component: () => import('/@/views/frontend/apply/member/consumptionList.vue'),
            meta: {
              title: '消费记录'
            }
          },
          {
            path: 'invoice',
            name: 'invoice',
            component: () => import('/@/views/frontend/apply/member/userInvoice/userInvoice.vue'),
            meta: {
              title: '我的发票'
            }
          },
          {
            path: 'drawingList',
            name: 'drawingList',
            component: () => import('/@/views/frontend/apply/member/drawingList.vue'),
            meta: {
              title: '我的图纸'
            }
          }
        ]
      },
      {
        path: 'tenderDocument',
        name: 'tenderDocument',
        redirect: '/tenderDocument/tenderDocumentHomePage',
        component: () => import('/@/views/frontend/apply/tenderDocument/index.vue'),
        meta: {
          title: '标书'
        },
        children: [
          {
            path: 'tenderDocumentHomePage',
            name: 'tenderDocumentHomePage',
            component: () => import('/@/views/frontend/apply/tenderDocument/homePage.vue'),
            meta: {
              title: '标书首页'
            }
          },
          {
            path: 'checkAnalyzeTender',
            name: 'checkAnalyzeTender',
            component: () => import('/@/views/frontend/apply/tenderDocument/checkAnalyzeTender.vue'),
            meta: {
              title: '查看解析招标文件'
            }
          },
          {
            path: 'bidArgsSetting',
            name: 'bidArgsSetting',
            component: () => import('/@/views/frontend/apply/tenderDocument/argsSetting.vue'),
            meta: {
              title: '投标参数配置'
            }
          },
          {
            path: 'generateCatalogue',
            name: 'generateCatalogue',
            component: () => import('/@/views/frontend/apply/tenderDocument/generateCatalogue.vue'),
            meta: {
              title: '生成目录'
            }
          },
          {
            path: 'bidReview',
            name: 'bidReview',
            component: () => import('/@/views/frontend/apply/tenderDocument/bidReview.vue'),
            meta: {
              title: '投标评分'
            }
          },
          {
            path: 'bidPublic',
            name: 'bidPublic',
            component: () => import('/@/views/frontend/apply/member/biddingAnnouncement.vue'),
            meta: {
              title: '招标公告'
            }
          },
          {
            path: 'bidList',
            name: 'bidList',
            component: () => import('/@/views/frontend/apply/member/tenderDocumentList.vue'),
            meta: {
              title: '我的标书'
            }
          },
          {
            path: 'tenderDocumentWriting',
            name: 'tenderDocumentWriting',
            component: () => import('/@/views/frontend/apply/tenderDocument/tenderDocumentWriting.vue'),
            meta: {
              title: '写作'
            }
          },
        ]
      },
      {
        path: 'businessOpportunity',
        name: 'businessOpportunity',
        component: () => import('/@/views/frontend/apply/member/biddingAnnouncement.vue'),
        meta: {
          title: '商机'
        }
      },
      {
        path: 'review',
        name: 'review',
        redirect: '/review/reviewIndex',
        component: () => import('/@/views/frontend/apply/review/review.vue'),
        meta: {
          title: '审查'
        },
        children: [
          {
            path: 'reviewIndex',
            name: 'reviewIndex',
            component: () => import('/@/views/frontend/apply/review/index.vue'),
            meta: {
              title: '审查首页'
            }
          }, {
            path: 'reviewRecord',
            name: 'reviewRecord',
            component: () => import('/@/views/frontend/apply/review/reviewRecord.vue'),
            meta: {
              title: '审查记录'
            }
          }, {
            path: 'reviewStartWriting',
            name: 'reviewStartWriting',
            component: () => import('/@/views/frontend/apply/review/startWriting.vue'),
            meta: {
              title: '审查'
            }
          },
        ]
      },
      {
        path: 'drawing',
        name: 'drawing',
        redirect: '/drawing/drawingIndex',
        component: () => import('/@/views/frontend/apply/drawing/drawing.vue'),
        meta: {
          title: '图纸'
        },
        children: [
          {
            path: 'drawingIndex',
            name: 'drawingIndex',
            component: () => import('/@/views/frontend/apply/drawing/index.vue'),
            meta: {
              title: '上传图纸'
            }
          },
          {
            path: 'projectDrawingLibrary',
            name: 'projectDrawingLibrary',
            component: () => import('/@/views/frontend/apply/drawing/projectDrawingLibrary.vue'),
            meta: {
              title: '项目图纸库'
            }
          }, {
            path: 'parameterPreview',
            name: 'parameterPreview',
            component: () => import('/@/views/frontend/apply/drawing/parameterPreview.vue'),
            meta: {
              title: '参数预览下载'
            }
          },
          {
            path: 'drawingReview',
            name: 'drawingReview',
            component: () => import('/@/views/frontend/apply/drawing/drawingReview.vue'),
            meta: {
              title: '图纸审查'
            }
          },
          {
            path: 'drawingReviewRecord',
            name: 'drawingReviewRecord',
            component: () => import('/@/views/frontend/apply/drawing/drawingReviewRecord.vue'),
            meta: {
              title: '图纸审查记录'
            }
          },
          {
            path: 'drawingGenerate',
            name: 'drawingGenerate',
            component: () => import('/@/views/frontend/apply/drawing/drawingGenerate.vue'),
            meta: {
              title: '工程量清单'
            }
          },
          {
            path: 'drawingGenerateRecord',
            name: 'drawingGenerateRecord',
            component: () => import('/@/views/frontend/apply/drawing/drawingGenerateRecord.vue'),
            meta: {
              title: '工程量清单记录'
            }
          }, {
            path: 'Vditor',
            name: 'Vditor',
            component: () => import('/@/components/Vditor/index.vue'),
            meta: {
              title: 'Vditor'
            }
          }
        ]
      },
      {
        path: 'chatPage',
        name: 'chatPage',
        component: () => import('/@/views/frontend/apply/chatPage.vue'),
        meta: {
          title: '问答'
        }
      },
      {
        path: 'pluginTool',
        name: 'pluginTool',
        component: () => import('/@/views/frontend/apply/pluginTool.vue'),
        meta: {
          title: '智能工具'
        }
      },
      {
        path: 'pluginCenter',
        name: 'pluginCenter',
        redirect: '/pluginCenter/ganttPage',
        component: () => import('/@/views/frontend/apply/pluginTool/pluginCenter.vue'),
        meta: {
          title: '插件中心'
        },
        children: [
          {
            path: 'ganttPage',
            name: 'ganttPage',
            component: () => import('/@/views/frontend/apply/pluginTool/gantt/ganttPage.vue'),
            meta: {
              title: '施工进度横道图'
            }
          },
          {
            path: 'imageGenerate',
            name: 'imageGenerate',
            component: () => import('/@/views/frontend/apply/pluginTool/imageGenerate/imageGenerate.vue'),
            meta: {
              title: '效果图生成'
            }
          },
          {
            path: 'imageGenerate2',
            name: 'imageGenerate2',
            component: () => import('/@/views/frontend/apply/pluginTool/imageGenerate/imageGenerate2.vue'),
            meta: {
              title: '效果图生成'
            }
          },
          {
            path: 'imageGenerate3',
            name: 'imageGenerate3',
            component: () => import('/@/views/frontend/apply/pluginTool/imageGenerate/imageGenerate3.vue'),
            meta: {
              title: '施工现场总平面布置图'
            }
          },
          {
            path: 'videoGenerate',
            name: 'videoGenerate',
            component: () => import('/@/views/frontend/apply/pluginTool/videoGenerate/videoGenerate.vue'),
            meta: {
              title: '视频生成'
            }
          },
          {
            path: 'generateTable',
            name: 'generateTable',
            component: () => import('/@/views/frontend/apply/pluginTool/generateTable/generateTable.vue'),
            meta: {
              title: '表格生成'
            }
          },
          {
            path: 'docCompare',
            name: 'docCompare',
            component: () => import('/@/views/frontend/apply/pluginTool/docCompare/index.vue'),
            meta: {
              title: '文档对比'
            }
          },
          {
            path: 'docCompare/detail',
            name: 'docCompareDetail',
            component: () => import('/@/views/frontend/apply/pluginTool/docCompare/detail.vue'),
            meta: {
              title: '文档对比详情'
            }
          },

        ]
      },
      {
        path: 'knowledgeBase',
        name: 'knowledgeBase',
        component: () => import('/@/views/frontend/apply/knowledgeBase.vue'),
        meta: {
          title: '知识库'
        }
      },
      {
        path: 'privateImageLibrary',
        name: 'privateImageLibrary',
        component: () => import('/@/views/frontend/apply/privateImageLibrary.vue'),
        meta: {
          title: '私有图库'
        }
      },
      {
        path: 'creditDatabase',
        name: 'creditDatabase',
        component: () => import('/@/views/frontend/apply/creditDatabase.vue'),
        meta: {
          title: '资信库'
        }
      },
      {
        path: '/editpwd',
        name: 'editpwd',
        component: () => import('/@/views/frontend/apply/member/password.vue'),
        meta: {
          title: '修改密码'
        }
      },
      {
        path: '/authentication',
        name: 'authentication',
        component: () => import('/@/views/frontend/apply/member/authentication.vue'),
        meta: {
          title: '企业认证'
        }
      },
      {
        path: '/test',
        name: 'test',
        component: () => import('/@/views/frontend/chat/test.vue'),
        meta: {
          title: 'test'
        }
      },

      {
        path: '/iframe',
        name: 'iframe',
        component: () => import('/@/views/frontend/chat/iframe.vue'),
        meta: {
          title: 'iframe'
        }
      }
    ]
  },
  {
    // 管理员登录页 - 不放在 adminBaseRoute.children 因为登录页不需要使用后台的布局
    path: adminBaseRoutePath + '/login',
    name: 'adminLogin',
    component: () => import('/@/views/backend/login.vue'),
    meta: {
      title: pageTitle('adminLogin')
    }
  },
  // {
  //     会员登录页
  //     path: memberCenterBaseRoutePath + '/login',
  //     name: 'userLogin',
  //     component: () => import('/@/views/frontend/user/login.vue'),
  //     meta: {
  //         title: pageTitle('userLogin'),
  //     },
  // },
  {
    path: '/:path(.*)*',
    redirect: '/404'
  },
  {
    // 404
    path: '/404',
    name: 'notFound',
    component: () => import('/@/views/common/error/404.vue'),
    meta: {
      title: pageTitle('notFound') // 页面不存在
    }
  },
  {
    // 后台找不到页面了-可能是路由未加载上
    path: adminBaseRoutePath + ':path(.*)*',
    redirect: (to) => {
      return {
        name: 'adminMainLoading',
        params: {
          to: JSON.stringify({
            path: to.path,
            query: to.query
          })
        }
      }
    }
  },
  // {
  //     会员中心找不到页面了
  //     path: memberCenterBaseRoutePath + ':path(.*)*',
  //     redirect: (to) => {
  //         return {
  //             name: 'userMainLoading',
  //             params: {
  //                 to: JSON.stringify({
  //                     path: to.path,
  //                     query: to.query,
  //                 }),
  //             },
  //         }
  //     },
  // },
  {
    // 无权限访问
    path: '/401',
    name: 'noPower',
    component: () => import('/@/views/common/error/401.vue'),
    meta: {
      title: pageTitle('noPower')
    }
  }
]

const staticFiles: Record<string, Record<string, RouteRecordRaw>> = import.meta.glob('./static/*.ts', { eager: true })
for (const key in staticFiles) {
  if (staticFiles[key].default) staticRoutes.push(staticFiles[key].default)
}

export default staticRoutes
